import firebase from 'firebase/app';
import 'firebase/auth';

const waitForLogin = ((callback) => {
  console.log('login.js->waitForLogin->waiting for user');
  firebase.auth().onAuthStateChanged(callback);
});

const sendPasswordResetEmail = ((emailAddress) => {
  const auth = firebase.auth();
  const settings = {
    url: "https://app.triploop.com/password_reset",
    // url: "https://dev.triploop.com/password_reset",
    handleCodeInApp: true,
  };
  return auth
    .sendPasswordResetEmail(emailAddress, settings);
  // .then(function () {
  //     console.log('success');
  //     // Email sent.
  // })
  // .catch(function (error) {
  //     console.log(error)
  //     // An error happened.
  // });
});

const forgotPassword = (() => {
  console.log("feel bad for you!");
});

const emailSignIn = ((email, password) => {
  console.log('signing a user in');
  return firebase.auth().signInWithEmailAndPassword(email, password);
});

const createUser = (email, password) => firebase.auth()
  .createUserWithEmailAndPassword(email, password);

const googleSignIn = (() => {
  const provider = new firebase.auth.GoogleAuthProvider();
  return firebase
    .auth()
    .signInWithPopup(provider);
});

const facebookLogin = (() => {
  const provider = new firebase.auth.FacebookAuthProvider();
  return firebase
    .auth()
    .signInWithPopup(provider);
});

const logout = () => firebase.auth().signOut();

export default {
  forgotPassword,
  emailSignIn,
  googleSignIn,
  facebookLogin,
  waitForLogin,
  createUser,
  sendPasswordResetEmail,
  logout,
};
